import { Radio as AntRadio } from 'antd';
import { FC } from 'react';
import { RadioProps } from './types';

interface Props extends RadioProps {}

export const Radio: FC<Props> = (props) => {
	const {
		label, //
		...rest
	} = props;

	return <AntRadio {...rest}>{label}</AntRadio>;
};
